import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IOutletDistanceDto, IOutletDto, IOutletFeaturesDto } from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class OutletService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOutletList(model: IOutletDistanceDto): Observable<IOutletDto[]> {
    return this.post(`outlet`, model);
  }

  public getOutletNames(id: number): Observable<KeyValue<number, string>[]> {
    return this.get(`outlet/${id}`);
  }

  public getOutletFeatures(id: number): Observable<IOutletFeaturesDto> {
    return this.get(`outlet/features/${id}`);
  }

  public validateOutlet(id: number): Observable<boolean> {
    return this.get(`outlet/validate/${id}`);
  }
}
